import { render } from "./Registration.vue?vue&type=template&id=7dd4e1eb"
import script from "./Registration.vue?vue&type=script&lang=js"
export * from "./Registration.vue?vue&type=script&lang=js"

import "./Registration.vue?vue&type=style&index=0&id=7dd4e1eb&lang=css"
import "./Registration.vue?vue&type=style&index=1&id=7dd4e1eb&lang=scss"

import exportComponent from "/var/www/dt_project_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__